import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
    position: "relative",
    transition: "background-color 0.2s ease",
  },
  checkboxContainer: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
  },
  cardContent: {
    paddingRight: 56,
  },
  clientName: {
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 4,
    color: "#006EB3",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  clientEmail: {
    fontSize: 14,
    color: "#666",
    wordBreak: "break-word",
  },
  memberChip: {
    backgroundColor: "#40628d",
    color: "#fff",
    fontSize: 11,
    height: 20,
    marginLeft: 8,
  },
});

export interface ClientSummary {
  name: string;
  email: string;
}

interface ClientSelectionCardProps {
  client: ClientSummary;
  isChecked: boolean;
  onChange: (client: ClientSummary) => void;
}

export default function ClientSelectionCard({
  client,
  isChecked,
  onChange,
}: ClientSelectionCardProps): React.ReactElement {
  const classes = useStyles();

  const handleCheckboxClick = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation();
    onChange(client);
  };

  return (
    <Card
      className={classes.card}
      variant="outlined"
      style={{
        backgroundColor: isChecked ? '#e7f6ff' : '#fff',
        borderColor: isChecked ? '#40628d' : '#e0e0e0',
        borderWidth: isChecked ? 2 : 1,
      }}
    >
      <div className={classes.checkboxContainer}>
        <Checkbox
          checked={isChecked}
          onChange={handleCheckboxClick}
          color="primary"
        />
      </div>

      <CardContent className={classes.cardContent}>
        <Typography className={classes.clientName}>
          {client.name}
          {isChecked && (
            <Chip
              label="Member"
              size="small"
              className={classes.memberChip}
            />
          )}
        </Typography>

        <Typography className={classes.clientEmail}>
          {client.email}
        </Typography>
      </CardContent>
    </Card>
  );
}
